<button
  [type]="type"
  [disabled]="disabled"
  [class]="className"
  [ngStyle]="buttonStyles"
  (click)="onClick()"
  class="app-button">
  <ng-content></ng-content>
  {{ text }}
</button>
